import { sysURL, server } from "../constants";
import axios from 'axios';


/**
 * getInfoNoVersion(), call info after login
 * Method: get
 * @returns 
 */
export function getInfoNoVersion() {
  return axios
    .get(`${sysURL.api}/info`)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}